import React,{useEffect,useState} from 'react';
import {nativeAds,readAdStatus} from '../utils/adClient';
export default function BotQuotaHint({username}){
 const [status,setStatus]=useState(null);
 useEffect(()=>{const c=new AbortController();if(navigator.onLine!==false&&nativeAds()?.mode==='live')readAdStatus(username,c.signal).then(s=>{if(!c.signal.aborted)setStatus(s);}).catch(()=>{});return()=>c.abort();},[username]);
 if(!status?.botGateEnabled)return null;
 return <p className="bot-quota-hint-r42" role="status">Bugün {status.bot?.remaining||0} bot maçı hakkın var. İlk 3 ücretsiz; sonrasında isteğe bağlı reklamla 3 ek maç açılır.</p>;
}
